import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, CardSubtitle, CardText, Spinner } from 'reactstrap';
import { ApplicationState } from "../store";
import { connect } from 'react-redux';
import * as AuthorizationStore from '../store/Authorization';
import { bindActionCreators } from "redux";
import qs from 'query-string';
import { StringUtils } from "../components/shared/StringUtils";
import Loader from '../components/shared/Loader';

const Auth = (props: {
    authorization: AuthorizationStore.IState;
    authorizationActions: typeof AuthorizationStore.actionCreators;
    rootCtrlProps?: React.HTMLAttributes<HTMLElement>;
}) => {

    const [errorMessage, setError] = useState<string>();

    useEffect(() => {
        getAuthCode();
    }, [props.authorization.azureConfig]);

    const getAuthCode = () => {
        const parsedUrl = qs.parseUrl(window.location.href);
        const query = parsedUrl.query;
        let code = "";
        let error_desc = "";
        let error = "";

        if (query) {
            code = query.code as string;
            error = query.error as string;
            error_desc = query.error_description as string;
        }

        if (!StringUtils.isEmpty(error) && !StringUtils.isEmpty(error_desc)) {
            if (StringUtils.startsWith(error_desc, "AADB2C90091")) {
                AuthorizationStore.removeFromLocalStorage('azure_ad_token');
                AuthorizationStore.removeFromLocalStorage('current_user');
                AuthorizationStore.removeFromLocalStorage('current_partner');
                document.location.assign("/login");
            }
            else if (StringUtils.startsWith(error_desc, "AADB2C90118")) {
                props.authorizationActions.redirectToAzurePasswordReset();
            }
        }

        if (StringUtils.isEmpty(code)) {
            console.log("Auth: Missing authorization code.");
            setError("Missing authorization code.");
        }
        else {
            props.authorizationActions.getAzureToken(code);
        }
    }

    return (
        <div className="p-3 container">
            {false &&
                <Card>
                    <CardBody>
                        <CardTitle tag="h5">Azure AD B2C Token</CardTitle>
                        <CardSubtitle tag="h6" className="mb-2 text-muted">Authentication</CardSubtitle>
                        {
                            !props.authorization.isLoading && props.authorization.azureToken &&
                            <CardText>
                                Success Token Request
                            </CardText>
                        }
                        {
                            !props.authorization.isLoading && props.authorization.errorMessage &&
                            <CardText>
                                {props.authorization.errorMessage}
                            </CardText>
                        }
                        {
                            errorMessage && !StringUtils.isEmpty(errorMessage) &&
                            <CardText>
                                {errorMessage}
                            </CardText>
                        }
                        {
                            props.authorization.isLoading &&
                            <div>
                                <Spinner color="primary" />
                            </div>
                        }
                    </CardBody>
                </Card>
            }
           <Loader />
        </div>
    );
};

export default connect((state: ApplicationState) => ({
    authorization: state.authorization
}), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        authorizationActions: bindActionCreators(AuthorizationStore.actionCreators, dispatch)
    })
)(Auth);